import React from "react";

export default function CheckoutProductsModal({ open, onClose }: { open: boolean; onClose: () => void }) {
    if (!open) return null;

    return (
        <div role="presentation" className="MuiDialog-root" id="checkout-products-modal" style={{ position: "fixed", zIndex: 1300, inset: "0px" }}>
            <div className="MuiBackdrop-root" aria-hidden="true" style={{ opacity: 1, transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)" }}></div>
            <div
                className="MuiDialog-container MuiDialog-scrollPaper"
                role="none presentation"
                tabIndex={-1}
                onClick={onClose}
                style={{
                    opacity: 1,
                    transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)"
                }}
            >
                <div
                    className="MuiPaper-root MuiDialog-paper MuiDialog-paperScrollPaper MuiDialog-paperWidthMd MuiDialog-paperFullWidth MuiPaper-elevation24 MuiPaper-rounded"
                    role="dialog"
                >
                    {/* ===== HEADER ===== */}
                    <div className="MuiDialogTitle-root">
                        <h2 className="MuiTypography-root MuiTypography-h6">
                            <div className="MuiBox-root css-69i1ev">
                                <h2 className="styles_title__Y0M1E">
                                    Danh sách sản phẩm (Số lượng: 7)
                                </h2>

                                <button
                                    className="MuiButtonBase-root MuiIconButton-root MuiIconButton-sizeSmall"
                                    type="button"
                                    id="checkout-products-modal-close"
                                    onClick={onClose}
                                >
                                    <span className="MuiIconButton-label">
                                        <svg
                                            className="MuiSvgIcon-root"
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                        >
                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                        </svg>
                                    </span>
                                    <span className="MuiTouchRipple-root"></span>
                                </button>
                            </div>
                        </h2>
                    </div>

                    {/* ===== BODY CONTENT ===== */}
                    <div className="MuiDialogContent-root">

                        <div className="MuiTableContainer-root">
                            <table className="MuiTable-root styles_cartItemsTable__HT5Rb">
                                <tbody className="MuiTableBody-root">

                                    {/* ==== từ đây bạn có thể map data ==== */}

                                    {/* 👉 Một block nhà cung cấp + sản phẩm */}
                                    {/* Bạn có thể copy thêm các block bên dưới tuỳ số sản phẩm */}

                                    {/* ==== SELLER HEADER ==== */}
                                    <tr className="MuiTableRow-root styles_noBorder__bNo5B">
                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall" colSpan={100}>
                                            <div className="MuiBox-root css-j0ozid">

                                                <div className="styles_sellerImage___lZqP">
                                                    <span style={{ position: "relative", display: "inline-block" }}>
                                                        <img
                                                            alt=""
                                                            aria-hidden="true"
                                                            src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28'/>"
                                                        />

                                                        <img
                                                            alt="Opella (Sanofi) Việt Nam"
                                                            src="https://gcs.buymed.com/thuocsi-live/images/2025447e390b5b3a59b835ab89468ae0?quality=100"
                                                            style={{
                                                                position: "absolute",
                                                                inset: 0,
                                                                margin: "auto",
                                                                minWidth: "100%",
                                                                minHeight: "100%"
                                                            }}
                                                        />
                                                    </span>
                                                </div>

                                                <div className="styles_sellerName__PC1wP MuiBox-root css-i9gxme">
                                                    Opella (Sanofi) Việt Nam
                                                </div>

                                                <div className="styles_header__UfJLh MuiBox-root css-epvm6">
                                                    1 sản phẩm
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    {/* ==== TABLE HEADER ==== */}
                                    <tr className="MuiTableRow-root styles_dashBorder__uLpxz">
                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-sizeSmall" width="50%">
                                            Sản phẩm
                                        </td>
                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignCenter MuiTableCell-sizeSmall">
                                            SL đặt
                                        </td>
                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignRight MuiTableCell-sizeSmall">
                                            Giá mua (đ)
                                        </td>
                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignRight MuiTableCell-sizeSmall">
                                            Tổng cộng (đ)
                                        </td>
                                    </tr>

                                    {/* ==== PRODUCT ROW ==== */}
                                    <tr className="MuiTableRow-root styles_lastBorder__U_ghb">
                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                            <div className="MuiBox-root css-j0ozid">

                                                <div className="styles_productImage__7FaA6">
                                                    <span style={{ position: "relative", display: "inline-block" }}>
                                                        <img
                                                            alt=""
                                                            aria-hidden="true"
                                                            src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100'/>"
                                                        />

                                                        <img
                                                            alt="Combo 160 Magne B6"
                                                            src="https://gcs.buymed.com/thuocsi-live/images/2024d52b50ff9f68cb3e2363bca5787b?quality=100"
                                                            style={{
                                                                position: "absolute",
                                                                inset: 0,
                                                                margin: "auto",
                                                                objectFit: "contain",
                                                                minWidth: "100%",
                                                                minHeight: "100%"
                                                            }}
                                                        />
                                                    </span>
                                                </div>

                                                <div className="styles_productName__FVRI6">
                                                    Combo 160 Magne B6 Corbiere Sanofi (hộp/50 viên nén)
                                                </div>
                                            </div>
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignCenter MuiTableCell-sizeSmall">
                                            4
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                            <div className="styles_flex_no_wrap__1vvft styles_justifyContentEnd__yd1n7 MuiBox-root css-0">
                                                <div className="styles_canvasPrice__vw932 MuiTableCell-alignRight text-[#005c29] text-[16px]" style={{ height: 25 }}> 12.918.000đ</div>
                                            </div>
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                            <div className="styles_flex_no_wrap__1vvft styles_justifyContentEnd__yd1n7 MuiBox-root css-0">
                                                <div className="styles_canvasPrice__vw932 MuiTableCell-alignRight text-[#005c29] text-[16px]" style={{ height: 25 }}> 61.918.000đ</div>
                                            </div>
                                        </td>
                                    </tr>

                                    {/* ==== Bạn copy thêm block seller khác tương tự ở dưới ==== */}

                                </tbody>
                            </table>
                        </div>

                        <div className="MuiTableContainer-root">
                            <table className="MuiTable-root styles_cartItemsTable__HT5Rb">
                                <tbody className="MuiTableBody-root">

                                    {/* ==== từ đây bạn có thể map data ==== */}

                                    {/* 👉 Một block nhà cung cấp + sản phẩm */}
                                    {/* Bạn có thể copy thêm các block bên dưới tuỳ số sản phẩm */}

                                    {/* ==== SELLER HEADER ==== */}
                                    <tr className="MuiTableRow-root styles_noBorder__bNo5B">
                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall" colSpan={100}>
                                            <div className="MuiBox-root css-j0ozid">

                                                <div className="styles_sellerImage___lZqP">
                                                    <span style={{ position: "relative", display: "inline-block" }}>
                                                        <img
                                                            alt=""
                                                            aria-hidden="true"
                                                            src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28'/>"
                                                        />

                                                        <img
                                                            alt="Opella (Sanofi) Việt Nam"
                                                            src="https://gcs.buymed.com/thuocsi-live/images/2025447e390b5b3a59b835ab89468ae0?quality=100"
                                                            style={{
                                                                position: "absolute",
                                                                inset: 0,
                                                                margin: "auto",
                                                                minWidth: "100%",
                                                                minHeight: "100%"
                                                            }}
                                                        />
                                                    </span>
                                                </div>

                                                <div className="styles_sellerName__PC1wP MuiBox-root css-i9gxme">
                                                    Opella (Sanofi) Việt Nam
                                                </div>

                                                <div className="styles_header__UfJLh MuiBox-root css-epvm6">
                                                    1 sản phẩm
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    {/* ==== TABLE HEADER ==== */}
                                    <tr className="MuiTableRow-root styles_dashBorder__uLpxz">
                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-sizeSmall" width="50%">
                                            Sản phẩm
                                        </td>
                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignCenter MuiTableCell-sizeSmall">
                                            SL đặt
                                        </td>
                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignRight MuiTableCell-sizeSmall">
                                            Giá mua (đ)
                                        </td>
                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignRight MuiTableCell-sizeSmall">
                                            Tổng cộng (đ)
                                        </td>
                                    </tr>

                                    {/* ==== PRODUCT ROW ==== */}
                                    <tr className="MuiTableRow-root styles_lastBorder__U_ghb">
                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                            <div className="MuiBox-root css-j0ozid">

                                                <div className="styles_productImage__7FaA6">
                                                    <span style={{ position: "relative", display: "inline-block" }}>
                                                        <img
                                                            alt=""
                                                            aria-hidden="true"
                                                            src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100'/>"
                                                        />

                                                        <img
                                                            alt="Combo 160 Magne B6"
                                                            src="https://gcs.buymed.com/thuocsi-live/images/2024d52b50ff9f68cb3e2363bca5787b?quality=100"
                                                            style={{
                                                                position: "absolute",
                                                                inset: 0,
                                                                margin: "auto",
                                                                objectFit: "contain",
                                                                minWidth: "100%",
                                                                minHeight: "100%"
                                                            }}
                                                        />
                                                    </span>
                                                </div>

                                                <div className="styles_productName__FVRI6">
                                                    Combo 160 Magne B6 Corbiere Sanofi (hộp/50 viên nén)
                                                </div>
                                            </div>
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignCenter MuiTableCell-sizeSmall">
                                            4
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                            <div className="styles_flex_no_wrap__1vvft styles_justifyContentEnd__yd1n7 MuiBox-root css-0">
                                                <div className="styles_canvasPrice__vw932 MuiTableCell-alignRight text-[#005c29] text-[16px]" style={{ height: 25 }}> 12.918.000đ</div>
                                            </div>
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                            <div className="styles_flex_no_wrap__1vvft styles_justifyContentEnd__yd1n7 MuiBox-root css-0">
                                                <div className="styles_canvasPrice__vw932 MuiTableCell-alignRight text-[#005c29] text-[16px]" style={{ height: 25 }}> 61.918.000đ</div>
                                            </div>
                                        </td>
                                    </tr>

                                    {/* ==== Bạn copy thêm block seller khác tương tự ở dưới ==== */}

                                </tbody>
                            </table>
                        </div>

                        <div className="MuiTableContainer-root">
                            <table className="MuiTable-root styles_cartItemsTable__HT5Rb">
                                <tbody className="MuiTableBody-root">

                                    {/* ==== từ đây bạn có thể map data ==== */}

                                    {/* 👉 Một block nhà cung cấp + sản phẩm */}
                                    {/* Bạn có thể copy thêm các block bên dưới tuỳ số sản phẩm */}

                                    {/* ==== SELLER HEADER ==== */}
                                    <tr className="MuiTableRow-root styles_noBorder__bNo5B">
                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall" colSpan={100}>
                                            <div className="MuiBox-root css-j0ozid">

                                                <div className="styles_sellerImage___lZqP">
                                                    <span style={{ position: "relative", display: "inline-block" }}>
                                                        <img
                                                            alt=""
                                                            aria-hidden="true"
                                                            src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28'/>"
                                                        />

                                                        <img
                                                            alt="Opella (Sanofi) Việt Nam"
                                                            src="https://gcs.buymed.com/thuocsi-live/images/2025447e390b5b3a59b835ab89468ae0?quality=100"
                                                            style={{
                                                                position: "absolute",
                                                                inset: 0,
                                                                margin: "auto",
                                                                minWidth: "100%",
                                                                minHeight: "100%"
                                                            }}
                                                        />
                                                    </span>
                                                </div>

                                                <div className="styles_sellerName__PC1wP MuiBox-root css-i9gxme">
                                                    Opella (Sanofi) Việt Nam
                                                </div>

                                                <div className="styles_header__UfJLh MuiBox-root css-epvm6">
                                                    1 sản phẩm
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    {/* ==== TABLE HEADER ==== */}
                                    <tr className="MuiTableRow-root styles_dashBorder__uLpxz">
                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-sizeSmall" width="50%">
                                            Sản phẩm
                                        </td>
                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignCenter MuiTableCell-sizeSmall">
                                            SL đặt
                                        </td>
                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignRight MuiTableCell-sizeSmall">
                                            Giá mua (đ)
                                        </td>
                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignRight MuiTableCell-sizeSmall">
                                            Tổng cộng (đ)
                                        </td>
                                    </tr>

                                    {/* ==== PRODUCT ROW ==== */}
                                    <tr className="MuiTableRow-root styles_lastBorder__U_ghb">
                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                            <div className="MuiBox-root css-j0ozid">

                                                <div className="styles_productImage__7FaA6">
                                                    <span style={{ position: "relative", display: "inline-block" }}>
                                                        <img
                                                            alt=""
                                                            aria-hidden="true"
                                                            src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100'/>"
                                                        />

                                                        <img
                                                            alt="Combo 160 Magne B6"
                                                            src="https://gcs.buymed.com/thuocsi-live/images/2024d52b50ff9f68cb3e2363bca5787b?quality=100"
                                                            style={{
                                                                position: "absolute",
                                                                inset: 0,
                                                                margin: "auto",
                                                                objectFit: "contain",
                                                                minWidth: "100%",
                                                                minHeight: "100%"
                                                            }}
                                                        />
                                                    </span>
                                                </div>

                                                <div className="styles_productName__FVRI6">
                                                    Combo 160 Magne B6 Corbiere Sanofi (hộp/50 viên nén)
                                                </div>
                                            </div>
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignCenter MuiTableCell-sizeSmall">
                                            4
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                            <div className="styles_flex_no_wrap__1vvft styles_justifyContentEnd__yd1n7 MuiBox-root css-0">
                                                <div className="styles_canvasPrice__vw932 MuiTableCell-alignRight text-[#005c29] text-[16px]" style={{ height: 25 }}> 12.918.000đ</div>
                                            </div>
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                            <div className="styles_flex_no_wrap__1vvft styles_justifyContentEnd__yd1n7 MuiBox-root css-0">
                                                <div className="styles_canvasPrice__vw932 MuiTableCell-alignRight text-[#005c29] text-[16px]" style={{ height: 25 }}> 61.918.000đ</div>
                                            </div>
                                        </td>
                                    </tr>

                                    {/* ==== Bạn copy thêm block seller khác tương tự ở dưới ==== */}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
